<template>
  <!-- Impersonation Tab - hangs down from center top -->
  <div
    v-if="authStore.isImpersonating"
    class="bg-orange-600 text-white shadow-lg rounded-b-lg"
    style="
      z-index: 999999 !important;
      position: fixed !important;
      top: 0 !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
    "
  >
    <div class="px-4 py-2 flex items-center space-x-3">
      <!-- Warning Icon -->
      <svg class="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
        <path
          fill-rule="evenodd"
          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
          clip-rule="evenodd"
        />
      </svg>

      <!-- Text -->
      <span class="font-medium text-sm whitespace-nowrap">
        Impersonating as
        {{ authStore.getImpersonationData?.originalUserEmail }}
      </span>

      <!-- Exit Button -->
      <button
        @click="stopImpersonation"
        :disabled="isStoppingImpersonation"
        class="px-3 py-1 bg-white text-orange-600 rounded-md hover:bg-gray-100 font-medium text-xs transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0"
      >
        <span v-if="isStoppingImpersonation">Stopping...</span>
        <span v-else>Exit</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";

import { useToast } from "@/composables/useToast";
import { useAuthStore } from "@/stores/auth";

const authStore = useAuthStore();
const { showToast } = useToast();
const isStoppingImpersonation = ref(false);

// Force check impersonation status when component mounts
onMounted(() => {
  authStore.checkImpersonationStatus();
});

const stopImpersonation = async () => {
  isStoppingImpersonation.value = true;

  try {
    // stopImpersonation will do a hard refresh, so we don't need to handle success/redirect
    await authStore.stopImpersonation();
  } catch (_error) {
    showToast("error", "Failed to stop impersonation");
    isStoppingImpersonation.value = false;
  }
};
</script>
